import { apiClient } from './client';
// Campaign API functions
export const campaignApi = {
    /**
     * Get all campaigns for a specific workspace
     */
    getCampaignsByWorkspace: (workspaceId) => apiClient.get(`/api/Campaigns/Workspace/${workspaceId}`),
    /**
     * Create a new campaign
     */
    createCampaign: (campaign) => apiClient.post('/api/Campaigns/CreateCampaign', campaign),
    /**
     * Update an existing campaign
     */
    updateCampaign: (campaign) => apiClient.put('/api/Campaigns/UpdateCampaign', campaign),
    /**
     * Get campaign web cards (assets)
     */
    GetCampaignWebCards: (clientCompanyId, workspaceId, campaignId) => apiClient.get(`/api/Campaigns/${clientCompanyId}/${workspaceId}/${campaignId}/Cards`),
};
